/**
 * GlobalStateRegistryService 实现
 *
 * 全局状态注册服务的核心实现，负责全局状态的注册、存储、查找和卸载。
 */
/**
 * 全局状态注册服务
 *
 * ui-registry-mod 的核心服务之一，业务 Mod 通过此服务注册全局状态。
 */
export class GlobalStateRegistryService {
    constructor(deps) {
        this.states = {};
        this.eventBus = deps?.eventBusService;
    }
    registerStates(modName, states) {
        // 校验状态名冲突
        for (const key of Object.keys(states)) {
            if (this.states[key]) {
                throw new Error(`Global state conflict: ${key} already registered`);
            }
        }
        // 批量注册
        Object.assign(this.states, states);
        if (this.eventBus) {
            this.eventBus.emit('state:registered', {
                modName,
                keys: Object.keys(states),
            });
        }
    }
    unregisterModStates(modName) {
        // 注意：这里无法直接判断哪些状态属于指定 mod，
        // 因为 registerStates 是直接合并的。
        // 实际实现中可以通过维护 modName → keys 的映射来解决。
        if (this.eventBus) {
            this.eventBus.emit('state:unregistered', { modName });
        }
    }
    getStates() {
        return { ...this.states };
    }
    getStatesByMod(_modName) {
        // 当前简单实现返回全量，后续可通过 modName → keys 映射优化
        return this.getStates();
    }
}
//# sourceMappingURL=global-state-registry.js.map